import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppServiceService } from '../../api/app-service.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {
  @Output() onPasswordResetSuccess: EventEmitter<any> = new EventEmitter();
  // below property came up with import customers csv feature
  @Input() invitedUserEmail: string = '';


  public value: any = {
    email: "",
    code: "",
    password: "",
    confirm_password: "",
  }
  public showPassword = false;
  public showrepeatPassword = false;
  public errors = false;

  public emailSending:boolean = false;
  public confirmInProgress:boolean = false;
  public resetInProgress:boolean = false;

  constructor(public appService: AppServiceService, public router: Router) { }

  ngOnInit() {
    // if invited userEmail has value
    // that means we already have the email address and code sent
    // skip email sending part and go straight to the code input ui 
    if (this.invitedUserEmail) {
      this.value.email = this.invitedUserEmail;
      this.appService.code_content = true;
      this.appService.email_content = false;
      this.appService.repeatpass_content = false;
    } else if (this.appService.appObject.invitedUserEmailRaw) { // will trigger in mobile view
      this.value.email = atob(this.appService.appObject.invitedUserEmailRaw);
      this.appService.code_content = true;
      this.appService.email_content = false;
      this.appService.repeatpass_content = false;

      // reset this value otherwise will triger in home single page when user visit home page
      this.appService.appObject.invitedUserEmailRaw = '';
      this.appService.updateAppObject();
    }

    this.appService.appObject.invitedUserEmail = '';
    this.appService.updateAppObject();
  }

  async sendEmailToReset() {
    this.emailSending = true;
    await this.appService.forgotPasswordEmail(this.value);
    this.emailSending = false;
  }


  async comfirmCode() {
    this.confirmInProgress = true;
    await this.appService.confirmVerifyCode(this.value);
    this.confirmInProgress = false;
  }

  async resetPassword() {
    this.errors = false;
    if (this.value.password == this.value.confirm_password) {
      this.resetInProgress = true;
      this.appService.resetOldPassword(this.value).then((response) => {

        if (this.appService.isWebVersion) this.onPasswordResetSuccess.emit();
        else this.router.navigate(['/login']);

      }, error => {
        this.appService.appObject.isLoading = false;
      }).finally(() =>{
        this.resetInProgress = false;
      });
    } else {
      this.errors = true;
    }
  }

  togglePassword(input) {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

}
